module.exports = __webpack_public_path__ + "img/2.130700b2.webp";